import { resolvePosStockUi } from '../../utils/posRetailStockDisplay';

/**
 * Badge / libellé stock retail (L3-S1) — informatif uniquement.
 */
export default function PosRetailStockHint({ display, variant = 'inline', className = '' }) {
  const ui = resolvePosStockUi(display);
  if (!ui) return null;

  if (variant === 'badge') {
    return (
      <span
        className={`inline-block px-2 py-0.5 rounded-md text-[10px] font-bold leading-tight ${ui.badgeClass} ${className}`}
        data-testid="pos-retail-stock-badge"
      >
        {ui.text}
      </span>
    );
  }

  return (
    <p
      className={`text-xs mt-1 ${ui.className} ${className}`}
      data-testid="pos-retail-stock-label"
    >
      {ui.text}
    </p>
  );
}
